import React from 'react';
import { Chip } from '@veevarts/design-system';

interface OfflineBadgeProps {
  className?: string;
}

/**
 * Small pill badge that indicates a service is currently unavailable.
 * Positioned absolutely — place inside a relative container.
 */
const OfflineBadge: React.FC<OfflineBadgeProps> = ({ className }) => {
  return (
    <Chip
      color="danger"
      size="sm"
      className={`absolute top-3 right-3 select-none pointer-events-none ${className ?? ''}`}
      aria-label="Service unavailable"
    >
      Unavailable
    </Chip>
  );
};

export default OfflineBadge;
